import { render, staticRenderFns } from "./CoordiList.vue?vue&type=template&id=7e20357d&"
import script from "./CoordiList.vue?vue&type=script&lang=js&"
export * from "./CoordiList.vue?vue&type=script&lang=js&"
import style0 from "./CoordiList.vue?vue&type=style&index=0&id=7e20357d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports